import { useEffect, useRef, useState } from "react";

type TypewriterProps = {
  text: string;
  onDone: () => void;
  onTyping?: (typing: boolean) => void;
  interruptRef?: React.MutableRefObject<boolean>;
};

const Typewriter: React.FC<TypewriterProps> = (props) => {
  const { text, onDone, onTyping, interruptRef } = props;

  const [displayed, setDisplayed] = useState("");
  const [allowAutoScroll, setAllowAutoScroll] = useState<boolean>(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleManualScroll = () => {
    setAllowAutoScroll(false);
  };

  useEffect(() => {
    let i = 0;
    onTyping?.(true);

    const interval = setInterval(() => {
      if (interruptRef?.current) {
        setDisplayed(text);
        clearInterval(interval);
        onTyping?.(false);
        onDone();
        return;
      }

      setDisplayed((prev) => prev + text.charAt(prev.length));
      i++;
      if (i === text.length) {
        clearInterval(interval);
        onTyping?.(false);
        onDone();
      }
    }, 15); // less interval more is speed

    window.addEventListener("wheel", handleManualScroll, { passive: true });
    window.addEventListener("touchstart", handleManualScroll, {
      passive: true,
    });

    return () => {
      clearInterval(interval);
      onTyping?.(false);
      window.removeEventListener("wheel", handleManualScroll);
      window.removeEventListener("touchstart", handleManualScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  useEffect(() => {
    if (allowAutoScroll) {
      containerRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [displayed, allowAutoScroll]);

  return (
    <>
      <p className="whitespace-pre-wrap text-medium text-gray-700">
        {displayed}
      </p>
      <div ref={containerRef} />
    </>
  );
};

export default Typewriter;
